function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { AttachmentBody } from "../../../../../customer/components";
import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
import ExpertTimePosted from "../expert-time-posted/ExpertTimePosted";
import { DialogueBody } from "../../../../../customer/components";
const ExpertAttachmentDialogue = ({
  classes,
  shouldAnimate,
  dialogue,
  ...rest
}) => {
  const {
    body,
    created,
    attachments
  } = dialogue;
  const hasBody = typeof body === "string";
  const {
    conversationState
  } = rest.message;
  const showExpertRating = conversationState.showExpertRating;
  return /*#__PURE__*/React.createElement(ExpertDialogueWrapper, _extends({
    shouldAnimate: shouldAnimate,
    dialogue: dialogue
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: hasBody ? classes.dialogueContainer : ""
  }, attachments && attachments.map((attachment, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.attachmentDailogueContainer,
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.attchmentDailogue
    }, /*#__PURE__*/React.createElement(AttachmentBody, {
      backgroundStyle: classes.background,
      textStyling: classes.bodyText,
      attachment: attachment
    })), hasBody && /*#__PURE__*/React.createElement("div", {
      className: `${classes.attchmentBody} ${showExpertRating ? "" : classes.bottomSpacing}`
    }, /*#__PURE__*/React.createElement(DialogueBody, {
      body: body,
      textStyling: classes.bodyText
    })));
  }), created && /*#__PURE__*/React.createElement(ExpertTimePosted, {
    dialogue: dialogue,
    time: created
  })));
};
const styles = ({
  palette
}) => ({
  dialogueContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end"
  },
  bodyText: {
    color: palette.primary.dark
  },
  attachmentDailogueContainer: {
    backgroundColor: palette.info.main,
    padding: "24px 32px 24px 24px",
    borderRadius: 20
  },
  attchmentDailogue: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  attchmentBody: {
    marginLeft: 8,
    marginTop: 0
  },
  bottomSpacing: {
    paddingBottom: 8
  }
});
export default withStyles(styles)(ExpertAttachmentDialogue);
ExpertAttachmentDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool.isRequired,
  isReported: PropTypes.bool,
  showExpertThumbnail: PropTypes.bool,
  hideExpertAvatar: PropTypes.bool
};
ExpertAttachmentDialogue.defaultProps = {
  isReported: false,
  showExpertThumbnail: true,
  hideExpertAvatar: false
};